import gql from 'graphql-tag'

export const LIST = gql`
  query procedures(
    $companyId: Int
    $procedureId: Int
    $departmentId: Int
    $employeeId: Int
    $from: String
    $to: String
    $states: [Int]
    $type: String
    $offset: Int = 0
    $limit: Int = 50
    $mode: RequestMode = MIK_TPRO
  )
  {
    procedures(
      companyId: $companyId
      procedureId: $procedureId
      departmentId:$departmentId
      employeeId: $employeeId
      from: $from
      to: $to
      states:$states
      type: $type
      offset: $offset
      limit: $limit
      mode: $mode
    )
    {
      id
      managerId
      managerName
      multiWinner
      participantsCount
      productCount
      rating
      stateId
      title
      type
      viewedCount
      dateAgreement
      dateClosed
      dateOpen
      dateCreated
  }
}
`
export const STATS = gql`
  query procedure_stats(
    $companyId: Int
    $departmentId: Int
    $employeeId: Int
    $type: String
    $states: [Int]
    $from: String
    $to: String
    $mode: RequestMode = MIK_TPRO
  )
  {
    procedures_stats(
      companyId: $companyId
      departmentId: $departmentId
      employeeId: $employeeId
      type: $type
      states: $states
      from: $from
      to: $to
      mode: $mode
    )
    { group count }
  }
`

export const WINNERS = gql`
  query procedureWinners($procedureId: Int) {
    procedureWinners(procedureId: $procedureId) {
      title
      companyId
      externalSupplier
      inn
    }
  }
`

export const DETAILS = gql`
  query procedure($procId: Int!) {
    procedure(id: $procId) {
      canceledReason
      dateAgreement
      dateClosed
      dateCreated
      dateOpen
      id
      managerId
      managerName
      minBidCount
      multiWinner
      participantsCount
      priceAvg
      priceMax
      priceMin
      productCount
      rating
      stateId
      title
      type
      viewedCount
      winnerId
      winnerName
      winnerPrice
      winnerReason
  }
}
`

export const DETAILS_LITE = gql`
  query procedureLite($filter: ProcedureFilter, $offset: Int, $limit: Int) {
    procedureLite(filter: $filter, offset: $offset, limit: $limit) {
      data {
        id title
      }
      total_count
    }
  }
`
